







import { Result } from '@empathy/search-types';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class ResultSuggestion extends Vue {
  @Prop({ required: true })
  suggestion: Result;

  @Prop()
  selected: boolean;
}
